import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" {...this.props}><path fill="#A4D06D" d="M16.688 25.728l-6.61-6.61 2.152-2.152 3.902 3.902 6.08-9.758 2.583 1.61" /><path fill="#A4D06D" d="M18 35.875C8.144 35.875.125 27.855.125 18S8.145.125 18 .125 35.875 8.145 35.875 18 27.855 35.875 18 35.875zm0-33.468C9.402 2.407 2.407 9.402 2.407 18c0 8.598 6.995 15.593 15.593 15.593 8.598 0 15.593-6.995 15.593-15.593 0-8.598-6.995-15.593-15.593-15.593z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/assets/icons/check-circle.svg